import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import ExpandedRatingRenderer from 'timeSheet/components/ExpandedRatingRenderer';

const useExpandedRatingColumn = ({
  onChangeRating,
  onExternalChangeRating,
  onEmployeeStatusChange,
  mappedSupplierBranches
}) => {
  const { t } = useContext(ConfigContext);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return ExpandedRatingRenderer({
        rowData: params.data,
        columnData: {
          onChangeRating,
          onExternalChangeRating,
          onEmployeeStatusChange,
          mappedSupplierBranches
        }
      });
    },
    [onChangeRating, onExternalChangeRating, onEmployeeStatusChange, mappedSupplierBranches]
  );

  return useMemo(
    () => ({
      field: 'rating',
      headerName: t('rating'),
      minWidth: 175,
      maxWidth: 185,
      width: 180,
      cellRenderer
    }),
    [t, cellRenderer]
  );
};

export default useExpandedRatingColumn;
